import { render, staticRenderFns } from "./NstechNotaRecusa.vue?vue&type=template&id=d0fb2bb6"
import script from "./NstechNotaRecusa.vue?vue&type=script&lang=js"
export * from "./NstechNotaRecusa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports